/**
 * Catálogo estático de áreas temáticas DC-3 (normativa MX).
 * Validación y selectores viven en frontend; el API solo persiste `thematic_area` como JSON.
 */
export interface Dc3ThematicAreaItem {
  code: string
  name: string
}

export const formatDc3ThematicAreaLabel = (
  area: Pick<Dc3ThematicAreaItem, 'code' | 'name'>
): string => `${area.code} ${area.name}`.trim()

export const resolveDc3ThematicArea = (
  area?: Partial<Dc3ThematicAreaItem> | null
): Dc3ThematicAreaItem | null => {
  if (!area) return null

  const code = String(area.code ?? '').trim()
  const name = String(area.name ?? '').trim()

  if (!code && !name) return null

  if (code) {
    const fromCatalog = DC3_THEMATIC_AREAS.find((item) => item.code === code)
    if (fromCatalog) {
      return { code: fromCatalog.code, name: fromCatalog.name }
    }

    return { code, name }
  }

  return { code: '', name }
}

export const formatDc3ThematicAreaForDisplay = (
  area?: Partial<Dc3ThematicAreaItem> | null
): string => {
  const resolved = resolveDc3ThematicArea(area)
  return resolved ? formatDc3ThematicAreaLabel(resolved) : ''
}

export const DC3_THEMATIC_AREAS: readonly Dc3ThematicAreaItem[] = [
  { code: '1000', name: 'Producción general' },
  { code: '2000', name: 'Servicios' },
  { code: '3000', name: 'Administración, contabilidad y economía' },
  { code: '4000', name: 'Comercialización' },
  { code: '5000', name: 'Mantenimiento y reparación' },
  { code: '6000', name: 'Seguridad' },
  { code: '7000', name: 'Desarrollo personal y familiar' },
  {
    code: '8000',
    name: 'Uso de tecnologías de la información y comunicación',
  },
  { code: '9000', name: 'Participación social' },
] as const
